import { useState, useEffect, useCallback } from 'react'
import useSetlists from '../hooks/useSetlists'
import PresentView from '../components/PresentView'

function PresentSection({ setlist, onLabelChange, onActionsChange }) {
  const { saveSetlist } = useSetlists()
  const [songs, setSongs] = useState(setlist.songs || [])
  const [previewLang, setPreviewLang] = useState('en')
  const [hasChanges, setHasChanges] = useState(false)

  useEffect(() => {
    onLabelChange(setlist.title || 'Present')
  }, [setlist.title, onLabelChange])

  useEffect(() => {
    onActionsChange([
      {
        label: previewLang === 'en' ? 'EN' : 'മ',
        onClick: () => setPreviewLang(p => p === 'en' ? 'ml' : 'en')
      }
    ])
    return () => onActionsChange([])
  }, [previewLang, onActionsChange])

  const handleAddSong = useCallback((song) => {
    setSongs(prev => [...prev, song])
    setHasChanges(true)
  }, [])

  const handleSave = useCallback(() => {
    saveSetlist({ ...setlist, songs })
    setHasChanges(false)
  }, [saveSetlist, setlist, songs])

  return (
    <PresentView
      title={setlist.title}
      date={setlist.date}
      songs={songs}
      previewLang={previewLang}
      onAddSong={handleAddSong}
      hasChanges={hasChanges}
      onSave={handleSave}
    />
  )
}

export default PresentSection
